import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router';
import * as Sentry from '@sentry/react';
import { Agentation } from 'agentation';
import ReactDOM from 'react-dom/client';

import { isPublicESignRoute } from './lib/isPublicSignerRoute';
import { PostHog } from './lib/PostHog';

import App from './App';

// Public eSign token routes carry bearer tokens in the URL. Skip every
// telemetry surface that captures URL or DOM contents.
const isPublicESign = isPublicESignRoute();

if (import.meta.env.PROD && !isPublicESign) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.replayIntegration()
    ],
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'UnhandledRejection',
      'Failed to fetch dynamically imported module'
    ],
    replaysSessionSampleRate: 0,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0
  });
}

if (!isPublicESign) {
  new PostHog().load();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
    {import.meta.env.DEV && <Agentation />}
  </React.StrictMode>
);
